import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressCountriesSlice = createSlice({
    name: "getAddressCountries",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressCountriesSlice_actions = getAddressCountriesSlice.actions;
export var fetchData = _getAddressCountriesSlice_actions.fetchData, fetchDataSuccess = _getAddressCountriesSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressCountriesSlice_actions.fetchDataFailure, resetState = _getAddressCountriesSlice_actions.resetState;
export default getAddressCountriesSlice.reducer;
